import { CompletionSystemBaseApi } from "./CompletionSystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class CompletionInstitutioninforApi extends CompletionSystemBaseApi {
  public get ControllerName(): any {
    return 'institutioninfor'
  }


  /**
   * 保存组织架构
   * @returns 
   */
  public saveOrUpdateInstitution(param) {
    return this.send(param, "saveOrUpdateInstitution", Methods.POST)
  }

  /**
   * 查询机构列表
   * @param id 
   */
  public getInstituionList(id) {
    return this.send({ id: id }, "getInstituionList", Methods.GET)
  }

  /**
   * 根据机构性质获取机构信息
   * @param id 
   * @param institutionNature 
   * @returns 
   */
  public getInstituionListByNature(id: number, institutionNature: number) {
    return this.send({ id, institutionNature }, "getInstituionListByNature", Methods.GET);
  }

  /**
   * 删除
   * @param id 
   */
  public deleteInstituion(id) {
    return this.send({}, "delete?id=" + id, Methods.POST)

  }

  /**
   * 机构单个保存树接口
   */
  public saveInstitution(param) {
    return this.send(param, "saveInstitution", Methods.POST)
  }

  /**
   * 保存机构和企业的关系
   * @param param 
   * @returns 
   */
  public saveEnterPriseRelation(param) {
    return this.send(param, "saveEnterPriseRelation", Methods.POST)

  }

  /**
  * 查询机构对象
  * @param id 
  */
  public getEntity(id) {
    return this.send({ id: id }, "getEntity", Methods.GET)
  }
  /**
   * 删除父节点同时删除子节点
   * @param id 
   * 
   */
  public deleteById(id) {
    return this.send({}, "deleteById?id=" + id, Methods.POST)
  }

  /**
   * 机构删除重写
   * @param data
   */
  public deleteOverwrite(data) {
    return this.send(data, "deleteOverwrite", Methods.POST)
  }
  /**
   * 机构Id查询机构列表
   * @param id 
   */
  public getInstitutionList(id) {
    return this.send({ id: id }, "getChildrenList", Methods.GET)
  }

  /**
   * 子系统ID查询机构列表
   * 条件不满足 需要增加子项目Id
   * @param id
   */
  public getListBySubsystemId(subSystemId) {
    return this.send({ subSystemId: subSystemId }, "getListBySubsystemId", Methods.GET)
  }

  /**
   * 子系统id项目id查询机构列表
   * @param id
   */
  public getBusinessInstitutionByProjectIdSub(subSystemId, ProjectId) {
    return this.send({ subSystemId: subSystemId, ProjectId: ProjectId }, "getBusinessInstitutionByProjectIdSub", Methods.GET)
  }
  /**
 * 子系统id项目id查询机构列表
 * @param id
 */
  public getAllListByProjectId(ProjectId) {
    return this.send({ projectId: ProjectId }, "getAllListByProjectId", Methods.GET)
  }

  public getInsByPathAndNature(projectId, insId, cIds) {
    return this.send({ projectId, insId, cIds }, "getInsByPathAndNature", this.Methods.GET);
  }

  /**
   * 根据层级关系查询机构
   * @param id
   */
  public getListByParams(params) {
    return this.send(params, "getListByParams", Methods.GET)
  }
  /**
   * 查询合同段列表
   * @param institutionId 
   * @returns 
   */
  public getContractPeriod(institutionId){
    return this.send({institutionId:institutionId}, "getContractPeriod", Methods.GET)
  }

  /**
   * 获取组织机构tree(v2.0) 规范版使用  zhangjl   chenrq 2023年3月2日
   * @param subProjectId
   */
  public getInstitutionTreeBySubProjectIdNew(subProjectId){
    return this.send({subProjectId:subProjectId}, "getInstitutionTreeBySubProjectIdNew", Methods.GET)
  }

  /**
   * 获取子级组织机构（v2.0）规范版使用  zhangjl   chenrq 2023年3月2日
   * @param institutionId
   */
  public getChildrenListNew(institutionId){
    return this.send({institutionId:institutionId}, "getChildrenListNew", Methods.GET)
  }

  /**
   * 删除机构及对应的关系
   * @param id 
   */
  public deleteRelation(id){
    return this.send({},"deleteRelation?id="+id,Methods.POST)
  }


  /**
   * 获取子级组织机构（v2.0）
   * @param institutionId
   */
  public getJLInstitutionin(institutionId){
    return this.send({id:institutionId}, "getJLInstitutionin", Methods.GET)
  }

  /**
   * 根据用户id获取组织机构
   * @param id 
   */
  public getUserIdByOrganizationId(userId){
    return this.send({userId:userId},'getUserIdByOrganizationId',this.Methods.GET)
  }

  /**
   * 根据用户id获取全部用户
   * @param id 
   */
  public getuserAll(userId){
    return this.send({userId:userId},'getUserAll',this.Methods.GET)
  }

  /**
   * 获取全部部门
   * @param id 
   */
  public getAllOrganization(userId){
    return this.send({userId:userId},'getAllOrganization',this.Methods.GET)
  }

  /**
   * 获取筛选部门
   * @param id 
   */
  public GetbyDepartmentId(deId){
    return this.send(deId,'byDepartmentId',this.Methods.POST)
  }

  /**
   * 获取筛选部门
   * @param id
   */
  public getIdByInstitutioninforelation(deId){
    return this.send(deId,'getIdByInstitutioninforelation',this.Methods.POST)
  }

}
